let { origin } = window.location;

const urlConfig = {
  homePage: {
    PA: "Modifying_My_Profile.htm",
    EU: "Web-based_Operations/Viewing_Home_Page.htm",
    EA: "Web-based_Operations/Viewing_Home_Page.htm",
  },
  usageReports: {
    PA: "Generating_Reports.htm",
    EU: "Reports.htm",
    EA: "Reports.htm",
  },
  insightsDashboard: {
    All_PA:      "Viewing_Dashboard_-_All.htm",
    All_EU:      "Web-based_Operations/Viewing_Dashboard_-_All.htm",
    All_EA:      "Web-based_Operations/Viewing_Dashboard_-_All.htm",

    SMS_PA:      "Home_Page.htm",
    SMS_EU:      "Web-based_Operations/Viewing_Dashboard.htm",
    SMS_EA:      "Web-based_Operations/Viewing_Dashboard.htm",

    WhatsApp_PA: "Viewing_Dashboard_-_WhatsApp.htm",
    WhatsApp_EU: "Web-based_Operations/Viewing_Dashboard_-_WhatsApp.htm",
    WhatsApp_EA: "Web-based_Operations/Viewing_Dashboard_-_WhatsApp.htm",

    Email_PA:    "Viewing_Dashboard_-_Email.htm",
    Email_EU:    "Web-based_Operations/Viewing_Dashboard_-_Email.htm",
    Email_EA:    "Web-based_Operations/Viewing_Dashboard_-_Email.htm",
  },
  billing: {
    _Billing_Info_EA: 'Viewing_Billing_Details.htm',
    _Transaction_History_EA: 'Viewing_Transaction_History.htm',
    _Billing_Info_EU: 'Viewing_Billing_Details.htm',
    _Transaction_History_EU: 'Viewing_Transaction_History.htm'
  },
  changeProfile: {
    PA: "Modifying_My_Profile.htm",
    EU: "Web-based_Operations/Managing_My_Profile/Managing_My_Profile.htm",
    EA: "Web-based_Operations/Managing_My_Profile/Managing_My_Profile.htm",
  },
  smsSenderAddress: {
    PA: "Managing_Sender_IDs.htm",
    EU: "Web-based_Operations/Managing_Sender_Addresses.htm",
    EA: "Web-based_Operations/Managing_Sender_Addresses.htm",
  },
  smsTemplates: {
    PA: "Viewing_Templates.htm",
    EU: "Web-based_Operations/Managing_Message_Templates/Viewing_Template.htm",
    EA: "Web-based_Operations/Managing_Message_Templates/Managing_Message_Templates.htm",
  },
  smsCampaigns: {
    PA: "Campaign_Management.htm",
    EU: "Web-based_Operations/Managing_Campaigns.htm",
    EA: "Web-based_Operations/Managing_Campaigns.htm",
  },
  smppSession: {
    PA: "Campaign_Management.htm",
    EU: "Campaign_Management.htm",  // EU uses Admin path — handled in buildUrl
    EA: "Managing_SMPP.htm",
  },
  voiceCampaign: {
    PA: "Viewing_Voice_Campaigns.htm",
    EU: "Viewing_Voice_Campaigns.htm",
    EA: "Web-based_Operations/Managing_Message_Templates/Voice_Management.htm",
  },
  voiceFileManager: {
    PA: "",
    EU: "Web-based_Operations/Campaign_Management/Uploading_Audio_Files.htm",
    EA: "",
  },
  whatsappProfile: {
    PA: "Viewing_WhatsApp_Profile.htm",
    EU: "Web-based_Operations/WhatsApp_Profile_Management.htm",
    EA: "Web-based_Operations/WhatsApp_Profile_Management/WhatsApp_Profile_Management.htm",
  },
  whatsappTemplates: {
    PA: "Viewing_WhatsApp_Templates_List.htm",
    EU: "Web-based_Operations/WhatsApp_Template_Management.htm",
    EA: "Web-based_Operations/WhatsApp_Template_Management%2FWhatsApp_Template_Management.htm",
  },
  whatsAppCampaign: {
    PA: "Viewing_WhatsApp_Campaign_List.htm",
    EU: "Web-based_Operations/WhatsApp_Campaign_Management.htm",
    EA: "Web-based_Operations/WhatsApp_Campaign_Management/WhatsApp_Campaign_Management.htm",
  },
  // Studio paths don't follow the standard pattern so full URLs are used
  studioDashboard: {
    EU: "/docs/StudioEU/Studio/Studio_Operations/Studio_Operations.htm",
    EA: "/docs/StudioEA/Web-based_Operations/Studio/Studio_Operations/Studio_Operations.htm",
  },
  studioEditor: {
    EU: "/docs/StudioEU/Studio/Studio_Components/Canvas/Canvas.htm",
    EA: "/docs/StudioEA/Web-based_Operations/Studio/Studio_Components/Canvas/Canvas.htm",
  },
  studioEditorLogs: {
    EU: "/docs/StudioEU/Studio/Studio_Components/Logs.htm",
    EA: "/docs/StudioEA/Web-based_Operations/Studio/Studio_Components/Logs.htm",
  },
  packages: {
    PA: "Package_Management.htm",
    EU: "Buying_Packages_-_SOB.htm",
    EA: "Buying_Packages_-_SOB.htm",
  },
  ratesheets: {
    PA: "Rate_Sheet_Management.htm",
    EU: "Viewing_Rate_List.htm",
    EA: "Viewing_Rate_List.htm",
  },
  roles: {
    PA: "Creating_Roles.htm",
    EU: "Role_Management.htm",
    EA: "Role_Management.htm",
  },
  users: {
    PA: "managing_cp_users.htm",
    EU: "Managing_Users.htm",
    EA: "Managing_Users.htm",
  },
  distributionList: {
    PA: "",
    EU: "Management_of_Distribution_List.htm",
    EA: "Management_of_Distribution_List.htm",
  },
  contactList: {
    PA: "",
    EU: "Web-based_Operations%2FManaging_Contacts/Creating_Contact.htm",
    EA: "Web-based_Operations/Managing_Contacts/Managing_Contacts.htm",
  },
  contactGroup: {
    PA: "",
    EU: "Web-based_Operations/Managing_Groups/Managing_Groups.htm",
    EA: "Web-based_Operations/Managing_Groups/Managing_Groups.htm",
  },
  segmentation: {
    PA: "",
    EU: "",
    EA: "",
  },
  logsActivity: {
    PA: "Viewing_Platform_Admin_Activity_Logs.htm",
    EU: "Viewing_Activities.htm",
    EA: "Viewing_Activities.htm",
  },
  logsDebug: {
    PA: "Viewing_Logs.htm",
    EU: "Viewing_Logs.htm",
    EA: "Viewing_Logs.htm",
  },
  logsEnterprise: {
    PA: "Viewing_Enterprise_Logs.htm",
    EU: "",
    EA: "",
  },
  notificationPA: {
    PA: "Viewing_Alerts.htm",
    EU: "Creating_Alerts.htm",
    EA: "Creating_Alerts.htm",
  },
  notification: {
    PA: "Configuring_Notification_Messages.htm",
    EU: "Viewing_Notifications.htm",
    EA: "Viewing_Notifications.htm",
  },
  numbersEA: {
    PA: "Managing_Candidates.htm",
    EU: "Web-based_Operations/Managing_Numbers.htm",
    EA: "Viewing_Number_List.htm",
  },
  numbersPA: {
    PA: "Managing_Candidates.htm",
  },
  reportsPA: {
    PA: "Generating_Reports.htm",
    EU: "",
    EA: "",
  },
  rateSheetPA: {
    PA: "Rate_Sheet_Management.htm",
  },
  packagesPA: {
    PA: "Package_Management.htm",
  },
  walletsPA: {
    PA: "Transferring_Credits.htm",
  },
  invoicingPA: {
    PA: "",
  },
  accountsPA: {
    PA: "Account_List.htm",
  },
  emailCampaigns: {
    PA: "Viewing_Email_Campaign_List.htm",
    EU: "Viewing_Email_Campaigns.htm",
    EA: "Web-based_Operations/Pushing_Messages/Viewing_Email_Campaigns.htm",
  },
  emailTemplates: {
    PA: "Viewing_Email_Template_List.htm",
    EU: "Web-based_Operations/Managing_Message_Templates/Managing_Email_Templates.htm",
    EA: "Web-based_Operations/Managing_Message_Templates/Managing_Email_Templates.htm",
  },
  emailAddressEA: {
    PA: "",
    EU: "",
    EA: "Web-based_Operations/Managing_Email_IDs.htm",
  },
  providersPA: {
    PA: "Managing_Providers.htm",
    EU: "",
    EA: "",
  },
  routersPA: {
    PA: "Creating_Rules.htm",
    EU: "",
    EA: "",
  },
  emailAddressPA: {
    PA: "Viewing_Address_Specification.htm",
    EU: "",
    EA: "",
  },
  quietTime: {
    PA: "Viewing_Quiet_Time_Storgae_List.htm",
    EU: "",
    EA: "Web-based_Operations/Creating_Quiet_Time_Storage.htm",
  },
  contentFilter: {
    PA: "Configuring_Filter_Keywords.htm",
    EU: "",
    EA: "",
  },
  blacklist: {
    PA: "Black_Lists.htm",
    EU: "",
    EA: "Web-based_Operations/Black_Lists.htm",
  },
  dnd: {
    PA: "Deleting_DND_Numbers.htm",
    EU: "",
    EA: "Web-based_Operations/Creating_DND_Categories.htm",
  },
  authConfig: {
    PA: "Viewing_AuthConfigs.htm",
    EU: "",
    EA: "Managing_AuthConfigs.htm",
  },  
  apiKeys: {
    PA: "",
    EU: "Managing_API_Keys.htm",
    EA: "Managing_API_Keys.htm",
  },
};

export default urlConfig;
